import { Injectable } from '@angular/core';
import { ConnectionService } from 'ng-connection-service';
import { BehaviorSubject, Subscription } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NetworkConnectionService {

  private networkConnectionState$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  public isOnline = this.networkConnectionState$.asObservable();

  private subscription = new Subscription();

  constructor(private connectionService: ConnectionService) { 
    this.subscription.add(connectionService.monitor({enableHeartbeat: false}).subscribe(state => {
      this.networkConnectionState$.next(state.hasNetworkConnection);
    }));
  }  

  unsubscribe(): void{
    this.subscription.unsubscribe();
  }
}
